import { gql } from '@apollo/client';

export default gql`
  mutation deleteWorkTicket($_id: String) {
    deleteWorkTicket(_id: $_id) {
      ok
      message
      error
    }
  }
`;
